import {
    connectToBLE,
    connectToUSB,
    deviceConnectionStatusTypes,
    initHolder,
    MW_ERRORS,
    subscribeOnConnectionState,
} from 'iqos-mw';

import marketConfigService from '@/services/marketConfigService';
import {setIsDeviceConnectedToIot, setIsHolderConnectedToIot} from '@/state/slices/deviceSlice';
import {
    setChargerConnectionStatus,
    setConnectionError,
    setDeviceInitializationData,
    setHolderInitializationData,
} from '@/state/slices/mwSlice';
import {dispatch} from '@/state/store';

import connectivityService from '../device/connectivityService';
import {sanitizeErrorForRedux} from '../errorService';

// Connection state management
const setupConnectionStateSubscriptions = () => {
    subscribeOnConnectionState((connectionStatus) => {
        if (!deviceConnectionStatusTypes.isConnected(connectionStatus)) {
            dispatch(setIsDeviceConnectedToIot(false));
            dispatch(setIsHolderConnectedToIot(false));
        }
        dispatch(setChargerConnectionStatus(connectionStatus));
    });
};

// Device initialization
const onDeviceInitialization = (data, onError) => {
    const {type} = data?.charger || {};
    const isDeviceSupported = marketConfigService.isDeviceSupported(type);

    if (!isDeviceSupported) {
        //TODO: IA
        onError({code: MW_ERRORS.ERROR_NOT_SUPPORTED_DEVICE.code});
        return;
    }

    dispatch(setDeviceInitializationData(data));
};

// USB connection handling
const initUsbConnection = ({onDeviceSelect, onError, isReconnect}) => {
    connectToUSB({
        isNewDevice: true,
        onDeviceSelect: () => onDeviceSelect?.(),
        onDeviceInitialization: (data) => onDeviceInitialization(data, onError),
        onError,
        isReconnect,
    });
};

// BLE connection handling
const initBleConnection = ({onDeviceSelect, onError}) => {
    connectToBLE({
        isNewDevice: true,
        onDeviceSelect: () => onDeviceSelect?.(),
        onDeviceInitialization: (data) => onDeviceInitialization(data, onError),
        onError,
        retryNumber: 0,
        isPairingDelayOnWindowsEnabled: true,
    });
};

const handleConnectionError = (e) => {
    const sanitizedError = sanitizeErrorForRedux(e);

    dispatch(setConnectionError(sanitizedError));
};

// Main device connection initialization
const initDeviceConnection = ({onConnect: onDeviceSelect, onError, isReconnect}) => {
    setupConnectionStateSubscriptions();

    const isBle = connectivityService.isBle();
    const onErrorHandler = (e) => {
        handleConnectionError(e);
        onError?.(e);
    };

    if (isBle) {
        initBleConnection({onDeviceSelect, onError: onErrorHandler});
    } else {
        initUsbConnection({onDeviceSelect, onError: onErrorHandler, isReconnect});
    }
};

// Main holder connection initialization
const initHolderConnection = async ({onSuccess, onError}) => {
    try {
        const holderData = await initHolder();

        dispatch(setHolderInitializationData(holderData));
        onSuccess?.();
    } catch (e) {
        dispatch(setHolderInitializationData({serial: undefined, codentify: undefined}));
        onError?.();
    }
};

export default {
    initDeviceConnection,
    initHolderConnection,
    handleConnectionError,
};
